import { connect } from 'react-redux'
import { lifecycle, compose } from 'recompose'
import { isLicenceFormActive } from '../selectors'
import { resetMakeAndModel, toggleYmme } from '../actions'
import MakeAndModel from './MakeAndModel'

export default compose(
  connect(
    state => ({ changeByLicencePlate: isLicenceFormActive(state) }),
    { resetMakeAndModel, toggleYmme }
  ),
  lifecycle({

    componentWillUnmount() {
      this.props.resetMakeAndModel()
    }
  })
)(MakeAndModel)
